import update from "react-addons-update";

import { clearState, saveState } from "../utils/poolTools";

import {
  CHANGE_POLL_PAGE,
  NEXT_POLL_PAGE,
  PREVIOUS_POLL_PAGE,
  CANCEL_CONFIRM_DIALOG,
  SEND_FORM,
  POLL_PROPERLY_SAVED,
  POLL_NOT_PROPERLY_SAVED,
  CLOSE_SAVE_ERROR_DIALOG
} from "../actions/types";

import PollConfig from "../utils/PollConfig";

export default (state = {}, action = {}) => {
  if (action.type && action.type === "@@redux/INIT") {
    // console.log("loading...");
  }
  let newState = null;
  switch (action.type) {
    case CHANGE_POLL_PAGE: {
      return update(state, { page: { $set: action.page } });
    }
    case NEXT_POLL_PAGE: {
      const config = new PollConfig();
      const actualPage = state.page || 0;

      if (actualPage === config.pagesCount() - 1) {
        newState = update(state, { sendFormPressed: { $set: true } });
        return newState;
      }

      const values = action.values || {};

      let nextPage = actualPage + 1;
      while (
        !config.canShow(nextPage, values) &&
        nextPage < config.pagesCount() - 1
      ) {
        nextPage += 1;
      }

      if (nextPage >= config.pagesCount()) nextPage = config.pagesCount() - 1;

      newState = update(state, { page: { $set: nextPage } });
      saveState("poll-form", newState);
      return newState;
    }
    case PREVIOUS_POLL_PAGE: {
      const config = new PollConfig();
      const values = action.values || {};
      const actualPage = state.page || 0;
      let previousPage = actualPage - 1;

      if (actualPage === 0) {
        action.history.push("/co_dalej");
        return state;
      }

      while (!config.canShow(previousPage, values) && previousPage >= 0) {
        previousPage -= 1;
      }
      // if (previousPage !== actualPage) {
      //   untouch("pollForm")
      // }
      newState = update(state, {
        page: { $set: previousPage },
        previousPage: { $set: previousPage }
      });
      saveState("poll-form", newState);
      return newState;
    }

    case CANCEL_CONFIRM_DIALOG: {
      newState = update(state, { sendFormPressed: { $set: false } });
      return newState;
    }
    case SEND_FORM: {
      newState = update(state, {
        sendFormPressed: { $set: false },
        savingPoll: { $set: true }
      });
      return newState;
    }
    case POLL_PROPERLY_SAVED:
      // reset formularza w bazie - akcja POLL_PROPERLY_SAVED  spowoduje rowniez
      // zmiane w storze forma za pomoca pluginu w reducerze forma
      newState = update(state, {
        page: { $set: 0 },
        savingPoll: { $set: false }
      });
      if (action.clear) {
        clearState("poll-form");
        clearState("poll-formValues");
      }
      return newState;
    case POLL_NOT_PROPERLY_SAVED:
      newState = update(state, {
        savingPoll: { $set: false },
        saveErrorInfo: { $set: true }
      });

      return newState;
    case CLOSE_SAVE_ERROR_DIALOG:
      newState = update(state, {
        saveErrorInfo: { $set: false }
      });

      return newState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/poll.js